import { useInfiniteQuery } from "@tanstack/react-query";
import { getTenantUserAssignmentsAudit } from "../api";

export function useTenantUserAssignmentsAudit(
  tenantId: string,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: ["tenant-user-assignments-audit", tenantId],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getTenantUserAssignmentsAudit(
        tenantId,
        pageParam as number,
        20,
      );
      return {
        data: response.data,
        pagination: response.pagination,
        nextPage:
          pageParam < response.pagination.totalPages
            ? (pageParam as number) + 1
            : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    enabled: enabled && !!tenantId,
  });
}
